module.exports = __webpack_public_path__ + "static/img/activity_sdy_01-3.41a9012.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_01-3.jpg
// module id = jKqz
// module chunks = 0